<template lang="pug">
  .result(:class="{result_fail: isFail}")
    .container
      .row
        .col-12.col-md-3.offset-md-1
          .result__pic
            img(:src="image", alt='')
        .col-12.col-md-7
          .title--decor
            h1.title--30(v-html="result.title")
          p.text--18(v-html="result.text")
          SocialList(:status="status")
          .pinkman
            p.text--20(v-html="result.cta")
          ButtonItem(
            text="Еще раз!"
            type="button"
            classList="button_sm"
            @click.native="restartGame")
</template>

<script>
  import ButtonItem from '@/components/ButtonItem.vue';
  import SocialList from '@/components/SocialList.vue';

  import { mapMutations, mapGetters, mapState } from 'vuex';
  import html_specialchars from 'html-specialchars';

  const STATUS_FAILURE = 0;
  const STATUS_ZHAROV = 1;
  const STATUS_USMANOV = 2;
  const STATUS_SUCCESS = 3;

  export default {
    name: 'Result',
    components: {
      SocialList,
      ButtonItem
    },
    methods: {
      ...mapMutations([
        'restartGame'
      ]),
      ...mapGetters([
        'getStatus',
        'getResults'
      ])
    },
    data() {
      return {
        images: {
          [STATUS_FAILURE]: require('@/assets/img/man/failure.svg'),
          [STATUS_ZHAROV]: require('@/assets/img/man/zharov.svg'),
          [STATUS_USMANOV]: require('@/assets/img/man/usmanov.svg'),
          [STATUS_SUCCESS]: require('@/assets/img/man/success.svg')
        },
        // status: 0
      }
    },
    computed: {
      ...mapState([
        'isFail'
      ]),
      status() {
        if(this.isFail) {
          // eslint-disable-next-line
          fbq('trackCustom', 'Lose');
          return STATUS_FAILURE;
        }
        if(this.score.pain >= 0 && this.score.pain < 20) {
          // eslint-disable-next-line
          fbq('trackCustom', 'Won');
          return STATUS_SUCCESS;
        }
        if(this.score.pain >= 20 && this.score.pain < 60) {
          // eslint-disable-next-line
          fbq('trackCustom', 'Won');
          return STATUS_ZHAROV;
        }
        if(this.score.pain > 60) {
          // eslint-disable-next-line
          fbq('trackCustom', 'Won');
          return STATUS_USMANOV;
        }
      },
      resultData() {
        return this.getResults();
      },
      image() {
        return this.images[this.status];
      },
      result() {
        return this.resultData[this.status];
      },
      score() {
        return this.getStatus()
      },
    },
    filters: {
      toHtml(value) {
        return html_specialchars.unescape(value);
      }
    }
  }
</script>

<style scoped lang="stylus">
.result
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: calc(100vh - 9rem)
  background-size contain
  background-position center center
  background-repeat no-repeat

  .title--decor
    width 100%
    @media $tablet
      width 90%
    &:before
      left 3%
      right 0
    &:after
      clip-path polygon(0% 0%, 97% 0, 100% 100%, 3% 100%)
    & > *
      width 100%
      padding 1.3rem 2rem
      font-size 2.4rem
      text-align left
      clip-path polygon(0% 0%, 97% 0, 100% 100%, 3% 100%)
      @media $tablet
        padding 3.1rem 5rem
        font-size 3rem
        text-align center
  &__pic
    max-width 42.5%
    margin: 0 auto 2rem
    @media $tablet
      max-width none
    img
      display block
      width 100%
  .social
    margin-top 2rem
    margin-bottom 4rem
    flex-flow: column wrap
    @media $tablet
      flex-flow: row wrap
      margin-top 4rem
      margin-bottom 2rem
    &__text
      text-align: center
      @media $tablet
        text-align: initial
  .title--decor
    margin-bottom 4rem
  .button
    display block
    margin 0 auto
    @media $tablet
      margin 0
      // display inline-block

  &_fail
    .title--decor
      & > *
        text-align center
        background-color #000000
    .social
      background-color rgba(#000000, 0.1)
    .result__pic
      filter grayscale(1)
    .pinkman
      background-color rgba(#000000, 0.8)
      .icon-pinkman
        &:hover
          color $pink
</style>
<style lang="stylus">
  .pinkman
    padding 2rem 3rem
    margin-bottom 4rem
    background-color rgba(#FF036D, 0.8)
    clip-path: polygon(0 0, 100% 3%, 97% 98%, 3% 100%)

    a
      display: inline-block
      border-bottom: 2px solid currentColor
      /*margin-left 1rem*/
      /*margin-right 1rem*/
      color $white
      transition color 0.3s ease
      text-decoration: none

      &:hover
        color $black

    p
      /*display flex*/
      /*align-items center*/
      /*justify-content center*/
      font-weight 600
      color: #FFF
      flex-flow: row wrap

    @media $tablet
      padding 2.3rem 6rem


</style>
